// src/components/SocialMediaProjects.js
import React, { useEffect, useRef } from "react";
import "../styles/SocialMediaProjects.css";
import rawClientData from "../assets/rawClientData.json";

// SocialMedia klasöründeki mevcut dosyaları otomatik olarak import et
function importAll(r) {
  let images = {};
  r.keys().forEach((item) => {
    images[item.replace('./', '')] = r(item);
  });
  return images;
}

// SocialMedia klasöründeki tüm .webp dosyalarını otomatik olarak yükle
const availableImages = importAll(
  require.context('../assets/SocialMedia', false, /\.webp$/)
);

const createPhoneScreen = (clientData) => {
  const fileName = `${clientData.shortName}.webp`;
  
  // Dosya mevcut mu kontrol et
  if (!availableImages[fileName]) {
    return null;
  }
  
  return {
    id: clientData.shortName.toLowerCase().replace(/\s+/g, '').replace(/[^a-zA-Z0-9]/g, ''),
    name: clientData.name,
    shortName: clientData.shortName,
    screenImage: availableImages[fileName]
  };
};

// Sadece mevcut image dosyaları olan client'ları kullan
const phoneScreens = rawClientData.sosyalMedya
  .map(client => createPhoneScreen(client))
  .filter(screen => screen !== null);

// Create infinite loop data
const createInfiniteData = (data) => {
  return [...data, ...data, ...data];
};

const SocialMediaProjects = () => {
  const sliderRef = useRef(null);
  const infiniteData = createInfiniteData(phoneScreens);

  useEffect(() => {
    const handleScroll = () => {
      if (!sliderRef.current) return;

      const slider = sliderRef.current;
      const phones = slider.querySelectorAll('.phone-container');
      const sliderRect = slider.getBoundingClientRect();
      const sliderCenter = sliderRect.left + sliderRect.width / 2;

      phones.forEach((phone) => {
        const phoneRect = phone.getBoundingClientRect();
        const phoneCenter = phoneRect.left + phoneRect.width / 2;
        const distanceFromCenter = Math.abs(phoneCenter - sliderCenter);
        const maxDistance = sliderRect.width / 2;
        
        const normalizedDistance = Math.min(distanceFromCenter / maxDistance, 1);
        
        // iPhone-style smooth opacity and scale transitions
        const opacity = Math.max(0.2, 1 - (normalizedDistance * 0.8));
        const scale = Math.max(0.85, 1 - (normalizedDistance * 0.15));
        
        phone.style.opacity = opacity;
        phone.style.transform = `scale(${scale})`;
      });
    };

    const handleInfiniteScroll = () => {
      if (!sliderRef.current) return;

      const slider = sliderRef.current;
      const scrollLeft = slider.scrollLeft;
      
      const itemWidth = 300 + 15; // phone width + gap
      const totalOriginalItems = phoneScreens.length;
      const sectionWidth = totalOriginalItems * itemWidth;

      // Smooth infinite scroll without jarring effects
      if (scrollLeft >= sectionWidth * 2 - 50) {
        slider.style.scrollBehavior = 'auto';
        slider.scrollLeft = sectionWidth + (scrollLeft - sectionWidth * 2);
        setTimeout(() => {
          slider.style.scrollBehavior = 'smooth';
        }, 50);
      } else if (scrollLeft <= 50) {
        slider.style.scrollBehavior = 'auto';
        slider.scrollLeft = sectionWidth + scrollLeft;
        setTimeout(() => {
          slider.style.scrollBehavior = 'smooth';
        }, 50);
      }
    };

    // Click handler for smooth scrolling to clicked item
    const handlePhoneClick = (event) => {
      const clickedPhone = event.currentTarget;
      const slider = sliderRef.current;
      if (!slider) return;

      const sliderRect = slider.getBoundingClientRect();
      const phoneRect = clickedPhone.getBoundingClientRect();
      const sliderCenter = sliderRect.left + sliderRect.width / 2;
      const phoneCenter = phoneRect.left + phoneRect.width / 2;
      const scrollOffset = phoneCenter - sliderCenter;

      slider.scrollBy({
        left: scrollOffset,
        behavior: 'smooth'
      });
    };

    const slider = sliderRef.current;
    if (slider) {
      const itemWidth = 300 + 15;
      const totalOriginalItems = phoneScreens.length;
      
 // İlk elemanın ortada başlaması için scroll pozisyonunu ayarla
      // Ekran genişliğinin yarısını hesapla ve ilk elemanı ortala
      const containerWidth = slider.offsetWidth;
      const firstItemCenterOffset = (containerWidth / 2) - (itemWidth / 2);
      
      // İkinci set başına geç (infinite scroll için) ama ilk eleman ortada olsun
      slider.scrollLeft = totalOriginalItems * itemWidth - firstItemCenterOffset;


      // Add click event listeners to all phone containers
      const phones = slider.querySelectorAll('.phone-container');
      phones.forEach(phone => {
        phone.addEventListener('click', handlePhoneClick);
      });

      slider.addEventListener('scroll', handleScroll);
      slider.addEventListener('scroll', handleInfiniteScroll);
      handleScroll();
    }

    return () => {
      if (slider) {
        const phones = slider.querySelectorAll('.phone-container');
        phones.forEach(phone => {
          phone.removeEventListener('click', handlePhoneClick);
        });
        slider.removeEventListener('scroll', handleScroll);
        slider.removeEventListener('scroll', handleInfiniteScroll);
      }
    };
  }, []);

  return (
    <div className="phone-slider" ref={sliderRef}>
      {infiniteData.map((screen, index) => (
        <div className="phone-container" key={`${screen.id}-${index}`}>
          <img 
            src={screen.screenImage} 
            alt={`${screen.id} phone screen`}
            className="phone-screen-image"
          />
        </div>
      ))}
    </div>
  );
};

export default SocialMediaProjects;